import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Box,CircularProgress, Button, Divider, TextField, IconButton } from '@mui/material';
import { updateProductassetObj, setSelectedProductassetId,setProductassetViewModal, setProductassetList, updateProductObj, setAssetcommentsList, addAssetcommentsObj, updateAssetcommentsObj } from 'store/slice/PharmaSlice';
import { getProductassetInfoByProductidAPI } from 'components/productasset/ProductassetAPI';
import ProductExpandCollapseBodyComposition from 'components/pharmaorder/components/vieworder/ProductExpandCollapseBodyComposition';
import { qaResponseDesignAPI, updateAssetStatusAPI } from 'api/OmsOrdermgmtWebServices';


import ErrorMessage from 'core/components/ErrorMessage';
import SuccessMessage from 'core/components/SuccessMessage';
import ViewActionModal from 'components/productasset/action/view/ViewActionModal';
import CustomerApprovedDesign from '../uploaddesign/CustomerApprovedDesign';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import UndoIcon from '@mui/icons-material/Undo';
import EditIcon from '@mui/icons-material/Edit';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import OpenInNewIcon from '@mui/icons-material/OpenInNew'; // Add this import
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { attachCommentAPI } from 'api/OmsOrdermgmtWebServices';
import {getAssetcommentsInfoByProductidAPI} from 'components/assetcomments/AssetcommentsAPI';


export default function QAworkspace() {
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { productassetObj } = useSelector((state) => state.pharmaslice.productassetDashboard);
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const dispatch = useDispatch();
    const [initiateRejection, setInitiateRejection] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [decision, setDecision] = useState(true);
    const [approvedAssets, setApprovedAssets] = useState([]);
    const [referredBackAssets, setReferredBackAssets] = useState([]);
    const [editingCommentAssetId, setEditingCommentAssetId] = useState(null);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editDialogAsset, setEditDialogAsset] = useState(null);
    const [editDialogComment, setEditDialogComment] = useState('');
    const [imageScale, setImageScale] = useState(1);
    const imgContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [scrollStart, setScrollStart] = useState({ left: 0, top: 0 });
    const {assetcommentsList, productassetList} = useSelector((state) => state.pharmaslice);
    const [qaAssetList, setQaAssetList] = useState([]);
    const [approveDialogOpen, setApproveDialogOpen] = useState(false);
    const [expiryDate, setExpiryDate] = useState('');
    const [batchNumber, setBatchNumber] = useState('');
    const [referBackConfirmOpen, setReferBackConfirmOpen] = useState(false);
    const [referBackAsset, setReferBackAsset] = useState(null);
    const [isQaDesignLocked, setIsQaDesignLocked] = useState(productObj.designstatusqa !== 'DESIGN WITH QA');
    const {taskList} = useSelector((state) => state.appslice.wkflow);

    useEffect(() => {
        getProductassetInfoByProductidAPI(productObj.id, ()=>{}, (response)=>{dispatch(setProductassetList(response))});
        getAssetcommentsInfoByProductidAPI(productObj.id, (response)=>{
            dispatch(setAssetcommentsList(response));
        }, (errMsg)=>{console.log(errMsg)});
        
    }, []);

    useEffect(() => {
        console.log('productAssetList', JSON.stringify(productassetList));
        setQaAssetList(
            productassetList && productassetList.length > 0
                ? productassetList.filter(asset => asset.imagetype === 'QA')
                : []
        );
    }, [productassetList]);

    useEffect(() => {

    }, [ productassetObj, assetcommentsList,productassetList, editDialogAsset]);
   
    useEffect(() => {
        setIsQaDesignLocked(productObj.designstatusqa !== 'DESIGN WITH QA');
    }, [productObj]);

    const isDesignReadyForAction = () => {
        // Return true if all QA assets have designstatus either blank or "REVIEW WIP"
        return (
            productassetList &&
            productassetList.length > 0 &&
            productassetList
                .filter(asset => asset.imagetype === 'QA')
                .every(asset => asset.designstatus === '' || asset.designstatus === 'REVIEW WIP')
        );
    };
    const apiSuccess = (response)=>{
        setApiInProgress(false);
        dispatch(updateProductObj(response.productInfo))
        if (response.productInfo.designstatusqa==="QA REFERRED BACK")
            setSuccessMsg("Design for '"+response.productInfo.title+"' is Referred Back !!!");
        else
            setSuccessMsg("Design for  '"+response.productInfo.title+"' is QA Approved !!!");
    }
    const apiFailure = (apiErrMsg)=>{
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
    }
    const handleActionSubmmission = (decision) =>{

        setDecision(decision);
        setErrMsg('')
        setApiInProgress(true);
        qaResponseDesignAPI({
            productId:productObj.id,  
            approve:decision,
            batchnumber: batchNumber,
            expirydate: expiryDate,
            taskInstanceId: taskList.find(task => task.boobjid === productObj.id)?.id || null,
        }, (response) => {
            apiSuccess(response);
            setApproveDialogOpen(false);
            dispatch(updateProductObj(response.productInfo));

        }
        , (errMsg) => {
            apiFailure(errMsg);
        }
        );
        
    }
    const getCommentByAssetId = (assetId) => {
        if (!assetcommentsList || assetcommentsList.length === 0) return '';
        const commentObj = assetcommentsList.find(comment => comment.assetid === assetId);
        return commentObj ? commentObj.title : '';
    };
    
    const handleAssetStatusUpdate = (assetId, status) => {
        setApiInProgress(true);
        updateAssetStatusAPI({
            productId: productObj.id,
            assetId: assetId,
            status: status
        }, (response) => {
            setApiInProgress(false);
            dispatch(updateProductassetObj(response.productassetInfo));
            
        }, (err) => {
            setApiInProgress(false);
            setErrMsg(err);
        });
    }

   
    // Revoke handler
    const handleRevoke = (assetObj) => {
        handleAssetStatusUpdate(assetObj.id, 'REVIEW WIP');
    };

    // Edit dialog open handler
    const handleEditDialogOpen = (asset) => {
        setEditDialogAsset(asset);
        setEditDialogComment(getCommentByAssetId(asset.id) || '');
        setEditDialogOpen(true);
    };

    // Edit dialog close handler
    const handleEditDialogClose = () => {
        setEditDialogOpen(false);
        //setEditDialogAsset(null);
    };

    // Save comment handler (optional, you can add API call here)
    const handleEditDialogSave = async () => {
        if (!editDialogAsset) return;
        setApiInProgress(true);
        try {
            // Replace with your actual API call for saving comment
            await attachCommentAPI({
                productId: productObj.id,
                assetId: editDialogAsset.id,
                comment: editDialogComment
            }, (response) => {
                if (response && response.newComment) 
                    dispatch(addAssetcommentsObj(response.assetcommentsInfo));
                else if (response && !response.newComment)
                    dispatch(updateAssetcommentsObj(response.assetcommentsInfo));
                
                //setEditDialogOpen(false);
                //setEditDialogAsset(null);
                setApiInProgress(false);
            }, (err) => {
                setErrMsg(err);
                setApiInProgress(false);
            });
        } catch (err) {
            setErrMsg('Failed to save comment');
            setApiInProgress(false);
        }
    };

    useEffect(() => {
        if (editDialogOpen) setImageScale(1);
    }, [editDialogOpen]);

    // Mouse event handlers for drag-to-scroll
    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStart({ x: e.clientX, y: e.clientY });
        if (imgContainerRef.current) {
            setScrollStart({
                left: imgContainerRef.current.scrollLeft,
                top: imgContainerRef.current.scrollTop,
            });
        }
    };
    const handleMouseMove = (e) => {
        if (!isDragging || !imgContainerRef.current) return;
        const dx = e.clientX - dragStart.x;
        const dy = e.clientY - dragStart.y;
        imgContainerRef.current.scrollLeft = scrollStart.left - dx;
        imgContainerRef.current.scrollTop = scrollStart.top - dy;
    };
    const handleMouseUp = () => setIsDragging(false);

    const handleOpenApproveDialog = () => {
        //setExpiryDate('');
        //setBatchNumber('');
        setApproveDialogOpen(true);
    };

    const handleApproveDesign = () => {
        // Add your API call here to submit expiryDate and batchNumber
        // Example:
        // qaApproveDesignAPI({ productId: productObj.id, expiryDate, batchNumber }, ...)
        handleActionSubmmission(true);
        setApproveDialogOpen(false);
        // Optionally show a success message or refresh data
    };

    return (
        <>
            <Grid
                container
                direction="row"
                sx={{
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    //padding: 1,
                    height: {lg:'75vh', md:'75vh', sm:'75vh', xs:'72vh'},
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                }}
            >
                {/* <Grid item lg={3} sm={3} xs={12} sx={{ width: '100%', backgroundColor: 'white'}}>
                    <CustomerApprovedDesign/>
                </Grid> */}
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{
                        width: '100%',
                        backgroundColor: 'white',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: 2,
                        //borderBottom: '1px solid #e0e0e0',
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        //ml: 2,
                        //padding: 2,
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: 'primary.lighter',
                            px: 2,
                            py: 1,
                            borderRadius: 1,
                            fontWeight: 'bold',
                            // mb: 1,
                            // mt: 2,
                            //mx: 2,
                            padding:1,
                            display: 'inline-block',
                        }}
                    >
                        Asset for QA approval
                    </Box>
                    {/* <Divider sx={{ mb: 2 }} /> */}
                    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto',backgroundColor: 'secondary.100', }}>
                        <Grid container sx={{ width: '100%',mt:1 }} justifyContent="center" alignItems="flex-start">
                            {qaAssetList.length > 0 ? (
                                qaAssetList.map((asset, idx) => (
                                    <Grid item key={asset.id} xs={12} sm={12} md={12} lg={10}>
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="stretch"
                                            
                                            sx={{
                                                width: '100%',
                                                mb: idx !== qaAssetList.length - 1 ? 1 : 0, // Only margin-bottom if not last asset
                                                backgroundColor: 'white',
                                                padding: 1, 
                                                mb: idx !== qaAssetList.length - 1 ? 5 : 0 // Only margin-bottom if not last asset
                                            }}
                                        >
                                            <Grid item lg={6} md={8} sm={8} xs={12}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        backgroundColor: 'secondary.100',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {/* Image */}
                                                    <Box sx={{ width: '300px', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img
                                                            src={asset.assetpath}
                                                            alt={asset.name}
                                                            style={{
                                                                width: '400px',
                                                                height: '300px',
                                                                borderRadius: '8px',
                                                                display: 'block',
                                                                padding: '10px',
                                                                pointerEvents: isQaDesignLocked ? 'none' : 'auto', // <-- disables click if locked
                                                                opacity: isQaDesignLocked ? 0.6 : 1, // optional: visual feedback
                                                                cursor: isQaDesignLocked ? 'not-allowed' : 'pointer'
                                                            }}
                                                            onClick={() => {
                                                                if (!isQaDesignLocked) handleEditDialogOpen(asset);
                                                            }} // <-- only open dialog if not locked
                                                        />
                                                    </Box>
                                                    <Typography
                                                        variant="body2"
                                                        noWrap
                                                        title={asset.name}
                                                        sx={{
                                                            maxWidth: '180px',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            display: 'block',
                                                            mt: 1,
                                                            color: '#1976d2',
                                                            textAlign: 'center',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        {asset.name}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid
                                                item
                                                lg={6}
                                                md={4}
                                                sm={4}
                                                xs={12}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    backgroundColor: 'white',
                                                    //mt: 1,
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {/* Review Comments section at the top */}
                                                <Box sx={{ width: '100%', mt:{xs:1}, ml: { xs: 0, sm: 1, md: 1, lg: 1 }, mb: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                                        <Typography
                                                            variant="subtitle2"
                                                            sx={{ fontWeight: 600, textAlign: 'left' }}
                                                        >
                                                            Review Comments
                                                        </Typography>
                                                        <IconButton
                                                            aria-label="edit"
                                                            size="small"
                                                            sx={{
                                                                ml: 1,
                                                                background: 'white',
                                                                boxShadow: 1,
                                                                '&:hover': { background: 'white' }
                                                            }}
                                                            onClick={() => handleEditDialogOpen(asset)}
                                                            disabled={isQaDesignLocked || apiInProgress} // <-- Add this line
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            backgroundColor: 'secondary.100',
                                                            borderRadius: 1,
                                                            p: 2,
                                                            minHeight: 80,
                                                            maxHeight: '30vh',
                                                            position: 'relative',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'flex-start',
                                                            textAlign: 'left',
                                                            overflowY: 'auto',
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                wordBreak: 'break-word',
                                                                whiteSpace: 'pre-wrap',
                                                                color: '#222', // Strong dark color for sharpness
                                                                fontWeight: 600, // Make text bolder
                                                                fontSize: 16,    // Slightly larger font
                                                                letterSpacing: 0.1,
                                                                textShadow: '0 1px 1px rgba(0,0,0,0.04)', // Subtle shadow for clarity
                                                            }}
                                                        >
                                                            {getCommentByAssetId(asset.id)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                {/* Status section below comments */}
                                                <Box sx={{ width: '100%', mt: 1, display: 'flex', justifyContent: 'center' }}>
                                                    {asset.designstatus==="APPROVED" && (
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: 100,
                                                                height: 100,
                                                                borderRadius: '50%',
                                                                backgroundColor: 'success.lighter',
                                                                border: '2px solid',
                                                                borderColor: 'success.main',
                                                                boxShadow: 1,
                                                                mx: 'auto',
                                                                p: 1,
                                                            }}
                                                        >
                                                            <SpellcheckIcon color="success" sx={{ fontSize: 32 }} />
                                                            <Typography
                                                                variant="subtitle2"
                                                                color="success.main"
                                                                sx={{ fontWeight: 600, fontSize: 13, mt: 0.5 }}
                                                            >
                                                                Approved
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                    {asset.designstatus==="REFERRED BACK" && (
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                width: 100,
                                                                height: 100,
                                                                borderRadius: '50%',
                                                                backgroundColor: 'error.lighter',
                                                                border: '2px solid',
                                                                borderColor: 'error.main',
                                                                boxShadow: 1,
                                                                mx: 'auto',
                                                                p: 1,
                                                            }}
                                                        >
                                                            <HighlightOffIcon color="error" sx={{ fontSize: 32 }} />
                                                            <Typography
                                                                variant="subtitle2"
                                                                color="error.main"
                                                                sx={{ fontWeight: 600, fontSize: 13, mt: 0.5 }}
                                                            >
                                                                Referred Back
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                                {/* Bottom-aligned actions */}
                                                <Box sx={{ width: '100%', padding: 1 }}>
                                                    {asset.designstatus === "" || asset.designstatus === "REVIEW WIP" ? (
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            fullWidth
                                                            onClick={() => handleEditDialogOpen(asset)}
                                                            disabled={isQaDesignLocked || apiInProgress}
                                                        >
                                                            Take Action
                                                        </Button>
                                                    ) : asset.designstatus === "APPROVED" || asset.designstatus === "REFERRED BACK" ? (
                                                        <Button
                                                            variant="outlined"
                                                            color="secondary"
                                                            fullWidth
                                                            onClick={() => handleRevoke(asset)}
                                                            disabled={isQaDesignLocked || apiInProgress}
                                                        >
                                                            Revoke Action
                                                        </Button>
                                                    ) : null}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Typography variant="body2" color="text.secondary" align="center" sx={{ p: 4 }}>
                                        No product assets found.
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                    
                </Grid>
                
            </Grid>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="outlined"
                    color="error"
                    sx={{ mr: 2 }}
                    disabled={isQaDesignLocked || isDesignReadyForAction() || apiInProgress}
                    startIcon={<ArrowBackIcon />}
                    onClick={() => setReferBackConfirmOpen(true)}
                >
                    Refer Back Design
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowForwardIcon />}
                    disabled={isQaDesignLocked || isDesignReadyForAction() || apiInProgress}
                    onClick={handleOpenApproveDialog}
                > Initiate Design Approval
                    </Button>
            </Box>

            {/* Edit Comment Dialog */}
            <Dialog open={editDialogOpen} onClose={handleEditDialogClose} maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                    <Typography variant="h6" sx={{ flex: 1 }}>{editDialogAsset?.name}</Typography>
                    <IconButton onClick={handleEditDialogClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ display: 'flex', flexDirection: 'row', pt: 2, minHeight: 400 }}>
                    {/* Left: Image center, zoomable, draggable */}
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'flex-start', // <-- Top align content
                            borderRight: '1px solid #e0e0e0',
                            pr: 2,
                            minHeight: 400,
                            maxHeight: 500,
                        }}
                    >
                        {editDialogAsset && (
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1, gap: 1, width: '100%' }}>
                                    <IconButton
                                        aria-label="zoom out"
                                        onClick={() => setImageScale(s => s / 1.2)}
                                    >
                                        <ZoomOutIcon />
                                    </IconButton>
                                    <IconButton
                                        aria-label="zoom in"
                                        onClick={() => setImageScale(s => s * 1.2)}
                                    >
                                        <ZoomInIcon />
                                    </IconButton>
                                    <Box sx={{ flex: 1 }} /> {/* Spacer to push the open icon to the right */}
                                    <IconButton
                                        aria-label="open in new tab"
                                        onClick={() => {
                                            if (editDialogAsset?.assetpath) {
                                                window.open(editDialogAsset.assetpath, '_blank', 'noopener,noreferrer');
                                            }
                                        }}
                                        sx={{ ml: 'auto' }}
                                    >
                                        <OpenInNewIcon />
                                    </IconButton>
                                </Box>
                                <Box
                                    ref={imgContainerRef}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: 350,
                                        overflow: 'auto',
                                        background: '#fafafa',
                                        borderRadius: 2,
                                        border: '1px solid #e0e0e0',
                                        cursor: isDragging ? 'grabbing' : 'grab',
                                        userSelect: 'none',
                                    }}
                                    onMouseDown={handleMouseDown}
                                    onMouseMove={handleMouseMove}
                                    onMouseUp={handleMouseUp}
                                    onMouseLeave={handleMouseUp}
                                >
                                    <img
                                        src={editDialogAsset.assetpath}
                                        alt={editDialogAsset.name}
                                        style={{
                                            display: 'block',
                                            width: `${200 * imageScale}px`,
                                            height: 'auto',
                                            maxWidth: 'none',
                                            maxHeight: 'none',
                                            transition: isDragging ? 'none' : 'width 0.2s',
                                            pointerEvents: 'none', // Prevent image from capturing mouse events
                                        }}
                                        draggable={false}
                                    />
                                </Box>
                            </>
                        )}
                    </Box>
                    {/* Right: Comments at top, buttons at bottom */}
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            pl: 2,
                            minHeight: 400,
                        }}
                    >
                        {/* Comments at the top */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                                Review Comments
                            </Typography>
                            {editDialogAsset && editDialogAsset.comment !== undefined && !editDialogAsset._editing ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start', // <-- Top align the content
                                        justifyContent: 'space-between',
                                        backgroundColor: 'secondary.100',
                                        borderRadius: 1,
                                        p: 1,
                                        minHeight: 300, // Large enough for 1024 chars
                                        //maxHeight: 200,
                                        overflowY: 'auto'
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            flex: 1,
                                            wordBreak: 'break-word',
                                            whiteSpace: 'pre-wrap',
                                            alignSelf: 'flex-start' // <-- Ensure text is top-aligned
                                        }}
                                    >
                                        {editDialogAsset.comment || <span style={{ color: '#aaa' }}>No comment</span>}
                                    </Typography>
                                    <IconButton
                                        aria-label="edit"
                                        sx={{ ml: 1, alignSelf: 'flex-start' }} // <-- Top align the icon
                                        onClick={() => {
                                            setEditDialogAsset({ ...editDialogAsset, _editing: true });
                                            setEditDialogComment(editDialogAsset.comment || '');
                                        }}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </Box>
                            ) : (
                                <>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={editDialogComment}
                                        onChange={e => {
                                            if (e.target.value.length <= 1024) setEditDialogComment(e.target.value);
                                        }}
                                        multiline
                                        minRows={7}
                                        maxRows={15}
                                        inputProps={{ maxLength: 1024 }}
                                        sx={{ backgroundColor: 'secondary.100' }}
                                    />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                                        <Typography variant="caption" color={editDialogComment.length === 1024 ? "error" : "text.secondary"}>
                                            {editDialogComment.length} / 1024 characters
                                        </Typography>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleEditDialogSave}
                                            disabled={editDialogComment.trim() === (editDialogAsset?.comment || '').trim() || apiInProgress}
                                        >
                                            Save
                                        </Button>
                                    </Box>
                                </>
                            )}
                        </Box>
                        {/* Buttons at the bottom */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<TaskAltIcon />}
                                onClick={() => {
                                    handleAssetStatusUpdate(editDialogAsset.id, "APPROVED");
                                    handleEditDialogClose();
                                }}
                                disabled={isQaDesignLocked || editDialogAsset?.designstatus === "APPROVED" || apiInProgress}
                            >
                                Approve
                            </Button>
                            <Button
                                variant="outlined"
                                color="error"
                                startIcon={<HighlightOffIcon />}
                                onClick={() => {
                                    handleAssetStatusUpdate(editDialogAsset.id, "REFERRED BACK");
                                    handleEditDialogClose();
                                }}
                                disabled={isQaDesignLocked || editDialogAsset?.designstatus === "REFERRED BACK" || apiInProgress}
                            >
                                Refer Back
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Approve Design Dialog */}
            <Dialog open={approveDialogOpen} onClose={() => setApproveDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    Approve Design
                    <IconButton onClick={() => setApproveDialogOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            label="Expiry Date"
                            type="date"
                            value={expiryDate}
                            onChange={e => setExpiryDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                        <TextField
                            label="Batch Number"
                            value={batchNumber}
                            onChange={e => setBatchNumber(e.target.value)}
                            fullWidth
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={() => setApproveDialogOpen(false)} color="secondary">
                        Cancel
                    </Button> */}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleApproveDesign}
                        disabled={!expiryDate || !batchNumber}
                    >
                        Approve Design
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirm Refer Back Dialog */}
            <Dialog open={referBackConfirmOpen} onClose={() => setReferBackConfirmOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Confirm Refer Back
        <IconButton onClick={() => setReferBackConfirmOpen(false)} size="small">
            <CloseIcon />
        </IconButton>
    </DialogTitle>
    <Divider />
    <DialogContent>
        <Typography>
            Are you sure you want to refer back DESIGN at product level?
        </Typography>
    </DialogContent>
    <DialogActions>
        <Button onClick={() => setReferBackConfirmOpen(false)} color="primary">
            Cancel
        </Button>
        <Button
            variant="contained"
            color="error"
            onClick={() => {
                handleActionSubmmission(false, null); // Pass null or the relevant asset if needed
                setReferBackConfirmOpen(false);
            }}
        >
            Yes, Refer Back
        </Button>
    </DialogActions>
            </Dialog>
        </>
    )
}